module.exports = __webpack_public_path__ + "img/fanhui.e20ca459.svg";